import { Button, Grid } from 'ui-toolkit';
import React from 'react';
import { ICreateHoaResponse, IGetHoaResponse, IHoaForm } from 'types/order/hoa/IHoaDetailsTypes';
import { FieldArray, Field, FieldProps, useFormikContext } from 'formik';
import { HoaRow } from './HoaRow';

export interface IHoaSummaryItemFormProps {
  onSave: (values: IHoaForm, index: number) => void;
  onDelete: (values: IHoaForm, index: number) => void;
  hoaDetails: IGetHoaResponse;
}

export const HoaSummaryItemForm: React.FC<IHoaSummaryItemFormProps> = ({ onSave, onDelete, hoaDetails }) => {
  const values: IHoaForm = useFormikContext().values as IHoaForm;

  return (
    <FieldArray name="hoas">
      {({ push, remove }) => (
        <Grid>
          <Field name="hoas">
            {({ field }: FieldProps<ICreateHoaResponse[]>) => (
              <>
                {field.value.map((hoa, index) => (
                  <HoaRow
                    key={index}
                    index={index}
                    hoa={hoa}
                    onDelete={onDelete}
                    onSave={onSave}
                    onRemoveNewHoa={remove}
                  />
                ))}
              </>
            )}
          </Field>
          {values.hoas.length <= hoaDetails.length && (
            <Button intent={'ghost'} type={'button'} onClick={() => push({})}>
              + Add an HOA
            </Button>
          )}
        </Grid>
      )}
    </FieldArray>
  );
};
